import httpClient from "@/api/http-client";

const ENDPOINT = "/evento/carrera/banner-publicitario";

export interface BannerPublicitarioCarreraDto {
  url: string;
}

class BannerService {
  //post
  editBanner(idBanner: number, createDto: FormData) {
    return httpClient.put(`${ENDPOINT}/${idBanner}`, createDto);
  }

  deleteImagen(idBanner: number) {
    return httpClient.delete(`${ENDPOINT}/${idBanner}`);
  }

  getBanners(idCarrera: string) {
    return httpClient.get(`${ENDPOINT}/${idCarrera}`);
  }

  getImageUrl(fileName: string): string {
    //const response = process.env.VUE_APP_API + ENDPOINT + "/" + fileName;
    if (fileName) {
      return `${process.env.VUE_APP_API}${ENDPOINT}/image/${fileName}`;
    }
    return "";
  }
}

export default new BannerService();
